import { useContext, useEffect } from 'react';
import { collectorLinks } from '../../../apps/sideMenuLinks/collector';
import SideMenuComponent from '../../../components/sideMenu/SideMenuComponent';
import { AlertState } from '../../../apps/state/AlertState';

type CollectorLayoutTypes = {
  location: any;
  children: JSX.Element;
};

const CollectorLayout = ({
  location,
  children,
}: CollectorLayoutTypes): JSX.Element => {
  const { alert } = useContext(AlertState);

  useEffect(() => {
    const access = localStorage.getItem('accessToken');

    if (access !== null) {
      const accessTokenData = JSON.parse(access);
      const faviconURL = `https://hg3.justwithu.com/${accessTokenData.setting.favicon}`;

      const link: HTMLLinkElement =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = faviconURL;

      document.head.appendChild(link);
    }

    if (alert.status) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
     // eslint-disable-next-line
  }, [alert.status]);

  return (
    <>
      <div className="grid grid-cols-5 p-3 md:p-8 space-y-5 mlg:space-y-0 mlg:gap-4 h-fit mlg:h-full">
        <SideMenuComponent menuItems={collectorLinks} location={location} />

        <div className="relative col-span-5 mlg:col-span-4 space-y-5">
          {children}
        </div>
      </div>
    </>
  );
};

export default CollectorLayout;
